const {addWindowListeners} = require('./window-handlers')
const {logger} = require('./utils')
const {GAME} = require('./constants')

const ADAPTERS = {
    [GAME.EMPIRE]: require('./game-adapters/empire'),
    [GAME.BIG_FARM]: require('./game-adapters/bigfarm'),
    [GAME.E4K]: require('./game-adapters/empirefourkingdoms')
}

const {OPEN, GET} = require('./constants')

const {init: initTracking} = require('./tracking')

function init(context) {
    logger.log(
        ' initialized successfully - waiting for player login',
        context.game
    )

    initTracking(context)
    const adapter = ADAPTERS[context.game]

    const logic = require('./announcement-events')(context, adapter)

    addWindowListeners(context)

    if (adapter.logoutCmd) {
        context.on(adapter.logoutCmd, logic.onLogout)
    }

    // TODO STP-367 BF protobufController emits events with message_name but CXFClient registers events with msgId  therefore we need to subscribe with both  ( when Stp-367 is merged we can just use String)
    context.once(3, () => {})
    context.once(24, () => {})

    context.once(adapter.loginCmd, logic.onLogin)
    context.on(GET, logic.onGetMessageStatus(GET))
    context.on(OPEN, logic.onOpenAnnouncements)
}

init(window.CXF)

module.exports.__internals = {
    ADAPTERS
}
